import React from "react";
import { FiCheck } from "react-icons/fi";

const FeatureItem = ({ text }) => {
  return (
    <div className="text-primary flex items-center gap-2 text-sm font-bold">
      <div className="text-primary flex size-5 items-center justify-center rounded-full bg-blue-100">
        <FiCheck size={14} />
      </div>
      {text}
    </div>
  );
};

export default FeatureItem;
